import {Routes} from '@angular/router';
import {AgreementPageComponent} from "./components/pages/agreement-page/agreement-page.component";
import {ContentPageComponent} from "./components/pages/content-page/content-page.component";
import {PrivacyPageComponent} from "./components/pages/privacy-page/privacy-page.component";
import {NotFoundComponent} from "./components/errors/not-found/not-found.component";
import {BlogDetailPageComponent} from "./components/pages/blog-detail-page/blog-detail-page.component";
import {BlogIndexPageComponent} from "./components/pages/blog-index-page/blog-index-page.component";
import {MainLayoutComponent} from "./layouts/main-layout/main-layout.component";
import {TemplatePageResolver} from "./resolvers/template-page.resolver";
import {CONTENT_PAGE_ROUTES, REDIRECT_ROUTES, STATIC_PAGE_ROUTES, toAngularPath,} from "./constants/routes";

const staticRouteComponents = {
    privacy: PrivacyPageComponent,
    agreement: AgreementPageComponent,
};

export const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            ...CONTENT_PAGE_ROUTES.map((route) => ({
                path: toAngularPath(route.path),
                component: ContentPageComponent,
                resolve: {
                    content: TemplatePageResolver,
                },
                data: {
                    templateId: route.templateId,
                    pageKey: route.pageKey,
                },
            })),
            {
                path: 'blog',
                component: BlogIndexPageComponent,
            },
            {
                path: 'blog/:slug',
                component: BlogDetailPageComponent,
            },
            ...REDIRECT_ROUTES.map((route) => ({
                path: toAngularPath(route.path),
                redirectTo: toAngularPath(route.redirectTo),
                pathMatch: 'full' as const,
            })),
            ...STATIC_PAGE_ROUTES.map((route) => ({
                path: toAngularPath(route.path),
                component: staticRouteComponents[route.component],
                resolve: {
                    content: TemplatePageResolver,
                },
                data: {
                    templateId: route.templateId,
                },
            })),
        ],
    },
    {
        path: '**',
        component: MainLayoutComponent,
        children: [
            {path: '', component: NotFoundComponent},
        ],
    },
];
